module.exports = __webpack_public_path__ + "static/media/char_sheet_square.85c40ab8.png";